import Image from '@atlaskit/image/image';

import { css } from '@compiled/react';

import { type JSX } from 'react/jsx-runtime';

import chatSpotDarkSvg from '../assets/chat-spot-dark.svg';

import chatSpotSvg from '../assets/chat-spot.svg';

import doodleCheckSvg from '../assets/doodle-check.svg';

import doodleSparkleBottomLeftDarkSvg from '../assets/doodle-sparkle-bl-dark.svg';

import doodleSparkleBottomLeftSvg from '../assets/doodle-sparkle-bl.svg';

import doodleSparkleTopRightDarkSvg from '../assets/doodle-sparkle-tr-dark.svg';

import doodleSparkleTopRightSvg from '../assets/doodle-sparkle-tr.svg';

import questionBadgeSvg from '../assets/question-badge.svg';

const SIZE = 40;

const rootStyles = css({
	position: 'relative',
	width: `${SIZE}px`,
	height: `${SIZE}px`,
	flexShrink: 0,
});

const layerStyles = css({
	position: 'absolute',
	display: 'block',
	maxWidth: 'none',
});

const chatSpotStyles = css({
	left: '5.96px',
	top: '7.27px',
	width: '28.04px',
	height: '25.41px',
});

const checkStyles = css({
	left: '17.89px',
	top: '16.89px',
	width: '10.77px',
	height: '10.55px',
});

const sparkleBottomLeftStyles = css({
	left: 0,
	top: '23px',
	width: '10.33px',
	height: '8.9px',
});

const sparkleTopRightStyles = css({
	left: '30px',
	top: '3px',
	width: '8.66px',
	height: '9.15px',
});

const questionBadgeStyles = css({
	left: '10px',
	top: '6px',
	width: '14px',
	height: '14px',
});

export const ExpertHelpSpotIllustration = (): JSX.Element => (
	<div css={rootStyles}>
		<Image css={[layerStyles, chatSpotStyles]} src={chatSpotSvg} srcDark={chatSpotDarkSvg} alt="" />
		<Image css={[layerStyles, checkStyles]} src={doodleCheckSvg} alt="" />
		<Image
			css={[layerStyles, sparkleBottomLeftStyles]}
			src={doodleSparkleBottomLeftSvg}
			srcDark={doodleSparkleBottomLeftDarkSvg}
			alt=""
		/>
		<Image
			css={[layerStyles, sparkleTopRightStyles]}
			src={doodleSparkleTopRightSvg}
			srcDark={doodleSparkleTopRightDarkSvg}
			alt=""
		/>
		<Image css={[layerStyles, questionBadgeStyles]} src={questionBadgeSvg} alt="" />
	</div>
);
